export default {
	'stock-quantities': 'كميات المخزون',
	'sample-name': 'اسم العينة',
	remaining: 'متبقي',
	'no-samples-to-show': 'لا توجد عينات للعرض',
}